module.exports = __webpack_public_path__ + "static/media/microservice.d231f5af.svg";